import styled from 'styled-components';
import { Button } from '../../utils/Button/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 1.6rem;
`;

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.6rem;

  @media only screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const MetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const MetaLabel = styled.span`
  font-size: 1.2rem;
  font-weight: 500;
  color: #6b7280;
  letter-spacing: -0.36px;
  text-transform: uppercase;
`;

export const MetaValue = styled.span`
  font-size: 1.5rem;
  font-weight: 500;
  color: #0b3a5f;
  letter-spacing: -0.45px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const SectionLabel = styled.span`
  font-size: 1.2rem;
  font-weight: 500;
  color: #6b7280;
  letter-spacing: -0.36px;
  text-transform: uppercase;
`;

export const SectionValue = styled.p`
  font-size: 1.5rem;
  font-weight: 400;
  color: #040b10;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const InteractionBubble = styled.div`
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 1.2rem;
  padding: 1.2rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const InteractionMeta = styled.span`
  font-size: 1.2rem;
  color: #6b7280;
  letter-spacing: -0.36px;
`;

export const InteractionText = styled.p`
  font-size: 1.5rem;
  font-weight: 400;
  color: #040b10;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const SeenBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 1rem;
  border-radius: 999px;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: -0.24px;
  background: ${({ $seen }) => ($seen ? '#E8F5EE' : '#E7F1FB')};
  color: ${({ $seen }) => ($seen ? '#1B8A4A' : '#1672BA')};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const SpinnerWrapper = styled.div`
  min-height: 20rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyText = styled.p`
  font-size: 1.4rem;
  color: #6b7280;
  text-align: center;
  padding: 3.2rem 0;
`;

export const GoToChatButton = styled(Button)`
  align-self: flex-start;
  width: 16rem;
`;
